import ozBuyingPowerCalculatorButton from './oz-buying-power-calculator-button.vue'

export default ozBuyingPowerCalculatorButton
